//  DEPENDENCIES //
// import { Link } from 'react-router-dom';
// import { deleteZombie } from '../../utils/api';

// COMPONENTS //
import BrushButton from '../BrushButton';


// STYLES //
import "./weapon.css";


export default function Weapon({ zombie, stopSound }) {
    return (
        <BrushButton
            className="weapon-button"
            // onClick={() => deleteZombie(zombie._id)}
            to="/outcome"
            onClick={stopSound}
        >
            Lay {zombie.name} to Rest
        </BrushButton>
    );
}